// ─────────────────────────────────────────────
// Server clock offset
//
// Export filenames + "Exported on" captions must reflect the SERVER's date and
// time, not the user's machine clock — otherwise someone who sets their system
// clock forward/back would stamp a wrong (and spoofable) time on downloads.
//
// There is no dedicated server-time API, but every HTTP response carries a
// standard `Date` header. baseQuery records it here on each response; we keep
// the offset between that server time and the local clock. `serverNow()` then
// returns a Date corrected by that offset, so exports are stamped with server
// time to within network latency (a few seconds), regardless of the local
// clock. Before any response is seen it falls back to the local clock.
// ─────────────────────────────────────────────

// milliseconds to ADD to Date.now() to get server time (serverMs - clientMs).
let offsetMs = 0;
let haveOffset = false;

/**
 * Record the server time from a response's `Date` header. Called by baseQuery
 * on every successful response; the most recent one wins, so the offset tracks
 * the live server even if the user's clock drifts during a session.
 */
export function recordServerDate(dateHeader: string | undefined | null): void {
  if (!dateHeader) return;
  const serverMs = Date.parse(dateHeader);
  if (Number.isNaN(serverMs)) return;
  offsetMs = serverMs - Date.now();
  haveOffset = true;
}

/** True once a server `Date` header has been seen this session. */
export function hasServerTime(): boolean {
  return haveOffset;
}

/**
 * Current server time as a Date. Falls back to the local clock until the first
 * response's Date header has been recorded.
 */
export function serverNow(): Date {
  return new Date(Date.now() + offsetMs);
}
